import React, {useCallback} from 'react';
import ZoomToButton from '@components/common/ZoomToButton';
import {fitExtent} from '@app/actions/map';
import {object} from 'prop-types';
import {trackEvent} from '@app/analytics';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';

const ZoomToCollectionButton = ({collection, ...props}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const onZoomTo = useCallback(() => {
    if (
      collection?.extent?.spatial?.bbox?.length > 0 &&
      Boolean(collection?.extent?.spatial?.bbox[0][0])
    ) {
      trackEvent('Collection Toolbar', {
        action: 'Zoomed to collection',
        featureId: collection.id,
      });
      dispatch(fitExtent(collection.extent?.spatial?.bbox[0]));
    }
  }, [collection, dispatch]);

  return (
    <ZoomToButton
      tooltipText={t('collectionToolbar.zoomTooltip')}
      onClick={() => onZoomTo(collection)}
      {...props}
    />
  );
};

ZoomToCollectionButton.propTypes = {
  collection: object.isRequired,
};

export default ZoomToCollectionButton;
